export default {
  // so we can redirect after we create a timeline
  CREATE_TIMELINE_SUCCESS: 'CREATE_TIMELINE_SUCCESS',

  // we dispatch, but don't currently respond to these photo upload lifecycle actions
  UPLOAD_TIMELINE_PHOTO_START: 'UPLOAD_TIMELINE_PHOTO_START',
  UPLOAD_TIMELINE_PHOTO_SUCCESS: 'UPLOAD_TIMELINE_PHOTO_SUCCESS',
  UPLOAD_TIMELINE_PHOTO_FAIL: 'UPLOAD_TIMELINE_PHOTO_FAIL',

  // we dispatch, but don't currently respond to these photo upload lifecycle actions
  UPLOAD_MARKER_PHOTO_START: 'UPLOAD_MARKER_PHOTO_START',
  UPLOAD_MARKER_PHOTO_SUCCESS: 'UPLOAD_MARKER_PHOTO_SUCCESS',
  UPLOAD_MARKER_PHOTO_FAIL: 'UPLOAD_MARKER_PHOTO_FAIL',

  // general entity actions
  RECEIVE_ENTITIES: 'RECEIVE_ENTITIES',
  REMOVE_ENTITY: 'REMOVE_ENTITY',

  // timelines
  RECEIVE_TIMELINES: 'RECEIVE_TIMELINES',
  RECEIVE_TIMELINE: 'RECEIVE_TIMELINE',

  // markers
  RECEIVE_MARKER: 'RECEIVE_MARKER',
  RECEIVE_MARKERS: 'RECEIVE_MARKERS',
  UPDATE_MARKER_ATTRIBUTE: 'UPDATE_MARKER_ATTRIBUTE',

  // timespans
  RECEIVE_TIMESPAN: 'RECEIVE_TIMESPAN',
  RECEIVE_TIMESPANS: 'RECEIVE_TIMESPANS',

  // photos
  RECEIVE_PHOTO: 'RECEIVE_PHOTO',
  RECEIVE_PHOTOS: 'RECEIVE_PHOTOS',
  RECEIVE_DEFAULT_PHOTO: 'RECEIVE_DEFAULT_PHOTO',
  PHOTO_DELETE_SUCCESS: 'PHOTO_DELETE_SUCCESS',

  // timeline grid items
  RECEIVE_TIMELINE_GRID_ITEMS: 'RECEIVE_TIMELINE_GRID_ITEMS',

  // categories
  RECEIVE_CATEGORIES: 'RECEIVE_CATEGORIES',

  // users
  RECEIVE_USERS: 'RECEIVE_USERS',
  RECEIVE_CURRENT_USER: 'RECEIVE_CURRENT_USER',
  REMOVE_USERS: 'REMOVE_USERS',

  // groups
  RECEIVE_GROUP: 'RECEIVE_GROUP',

  // timeline comments
  RECEIVE_TIMELINE_COMMENTS: 'RECEIVE_TIMELINE_COMMENTS',

  // embed keys
  RECEIVE_EMBED_KEYS: 'RECEIVE_EMBED_KEYS',
  LOAD_EMBED_KEY_START: 'LOAD_EMBED_KEY_START',
  LOAD_EMBED_KEY_SUCCESS: 'LOAD_EMBED_KEY_SUCCESS',
  LOAD_EMBED_KEY_FAIL: 'LOAD_EMBED_KEY_FAIL',

  // timeline tags
  RECEIVE_TAGS: 'RECEIVE_TAGS',

  // permissions
  PERMISSION_DELETE_SUCCESS: 'PERMISSION_DELETE_SUCCESS',

  // UI ACTIONS

  // toasts
  ADD_TOAST: 'ADD_TOAST',
  REMOVE_TOAST: 'REMOVE_TOAST',

  // react users
  RECEIVE_REACT_USERS: 'RECEIVE_REACT_USERS',
  RECEIVE_GROUPS: 'RECEIVE_GROUPS',

  // endpoints
  RECEIVE_ENDPOINTS: 'RECEIVE_ENDPOINTS',

  // field select options
  FIELD_SELECT_OPTION_DELETED: 'FIELD_SELECT_OPTION_DELETED',

  // ads
  AD_VISIBILITY_CHANGE: 'AD_VISIBILITY_CHANGE',
  AD_CHANNEL_CHANGE: 'AD_CHANNEL_CHANGE',

  // flash messages
  RECEIVE_FLASH: 'RECEIVE_FLASH',
  CLEAR_FLASH: 'CLEAR_FLASH',

  // color schemes
  CURRENT_COLOR_SCHEME_CHANGE: 'CURRENT_COLOR_SCHEME_CHANGE',
  EDITABLE_COLOR_SCHEME_CHANGE: 'EDITABLE_COLOR_SCHEME_CHANGE',
}
